module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Clipboard-b30f2dbd8ecdd7043dac8e3018c199f2.svg";